import axios from 'axios';
import { BaseAPI } from './BaseAPI';

export class CaptchaAPI extends BaseAPI {
  //短信
  async getQuerySMS(params) {
    const { data } = await axios.get(`${this._getBasePathPublic()}/query/otp`, {
      params: params,
    });
    return data;
  }
  //短信
  async getSMS(params) {
    const { data } = await axios.get(`${this._getBasePathPublic()}/otp`, {
      params: params,
    });
    return data;
  }

  async captcha() {
    const { data } = await axios.get(`${this._getBasePathPublic()}/captcha`, {
      responseType: 'blob',
    });
    return data;
  }
}

export default new CaptchaAPI({
  prefix: '',
  path: '',
});
